import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPolicyRoutingModule } from './privacy-policy-routing.module';


@NgModule({
  declarations: [],
  imports: [
    PrivacyPolicyRoutingModule,
    CommonModule
  ]
})
export class PrivacyPolicyModule { }
